import Icon from 'veui/components/Icon'
import { IconInfoCircle } from 'dls-icons-vue'

Icon.register('info-circle', IconInfoCircle)
